import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { Constants } from '../constants/constants';
import { catchError, map, Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CompaniesService {
    private companyConfigUrl: string = `${Constants.apiUrl}/companies`;

    constructor(
        private router: Router,
        private http: HttpClient
    ) {}

    private getCompanyConfiguration(companyId: string) {
        const params = new HttpParams().set('brand', companyId);

        return this.http.get<any>(`${this.companyConfigUrl}/configuration`, { params });
    }

    getCompanyLoginConfiguration(companyId: string): Observable<any> {
        const defaultCompanyConfiguration = {
            company: null
        };

        if (!companyId) {
            // Dialenga login, no company value is specified
            return of(defaultCompanyConfiguration);
        } else {
            return this.getCompanyConfiguration(companyId).pipe(
                map((response) => {
                    const sortedSSOConfigs = (response?.loginConfiguration?.ssoConfigs ?? []).slice().sort((a: any, b: any) => {
                        if (a.order !== b.order) return a.order - b.order;

                        return a.id - b.id;
                    });

                    return {
                        ...response,
                        loginConfiguration: {
                            ...response.loginConfiguration,
                            ssoConfigs: sortedSSOConfigs
                        },
                        company: companyId
                    };
                }),
                catchError((error) => {
                    // TODO: handle 404 error to avoid redirection
                    // Company not found, assume default login kind
                    console.error(error);

                    // Remove c parameter
                    this.router.navigate([], {
                        queryParams: { c: null },
                        queryParamsHandling: 'merge',
                        replaceUrl: true
                    });
                    localStorage.removeItem('lastUserLoginBrand');
                    return of(defaultCompanyConfiguration);
                })
            );
        }
    }

    private getTestflightConfiguration(companyId: string) {
        const params = new HttpParams().set('brand', companyId);

        return this.http.get<any>(`${this.companyConfigUrl}/apple-testflight`, { params });
    }

    getTestflightCompanyConfiguration(companyId: string): Observable<any> {
        return this.getTestflightConfiguration(companyId);
    }
}
